// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_confirm_record_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_confirm_record_model.proto.
 */
export const file_bffuser_v1_demand_confirm_record_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * DemandConfirmRecordSummary is the list-row projection.
 *
 * @generated from message bffuser.v1.DemandConfirmRecordSummary
 */
export type DemandConfirmRecordSummary = Message<"bffuser.v1.DemandConfirmRecordSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.PlanningSection planning_section = 4;
   */
  planningSection: PlanningSection;

  /**
   * @generated from field: bffuser.v1.ConfirmCategory confirm_category = 5;
   */
  confirmCategory: ConfirmCategory;

  /**
   * @generated from field: bffuser.v1.AggregationScope aggregation_scope = 6;
   */
  aggregationScope: AggregationScope;

  /**
   * scope_identifier is polymorphic on aggregation_scope: retailer
   * BusinessCd (4-char) for RETAIL, empty for BG_TOTAL, group name for
   * DEMAND_GROUP.
   *
   * @generated from field: string scope_identifier = 7;
   */
  scopeIdentifier: string;

  /**
   * @generated from field: string case_id = 8;
   */
  caseId: string;

  /**
   * @generated from field: string provider_name = 9;
   */
  providerName: string;

  /**
   * @generated from field: optional google.type.Decimal max_power_kwh = 10;
   */
  maxPowerKwh?: Decimal;

  /**
   * @generated from field: optional google.protobuf.Timestamp max_power_time = 11;
   */
  maxPowerTime?: Timestamp;

  /**
   * @generated from field: string confirmed_by = 12;
   */
  confirmedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp confirmed_at = 13;
   */
  confirmedAt?: Timestamp;

  /**
   * @generated from field: optional string approved_by = 14;
   */
  approvedBy?: string;

  /**
   * bg_code is the record's submission-responsible BG (OCCTO 5-char code).
   * Always populated. Field number matches internalapi.v1's bg_code (= 19);
   * 15-18 stay free because the BFF message collapses the provider triple
   * (provider / provider_other / provider_label) into a single provider_name.
   *
   * @generated from field: string bg_code = 19;
   */
  bgCode: string;
};

/**
 * Describes the message bffuser.v1.DemandConfirmRecordSummary.
 * Use `create(DemandConfirmRecordSummarySchema)` to create a new message.
 */
export const DemandConfirmRecordSummarySchema: GenMessage<DemandConfirmRecordSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_model, 0);

/**
 * PlanningSection classifies the operational planning period of the
 * demand confirm record (計画断面: 当日 / 翌日 / 翌々日 / 週間 / 月間 / 年間).
 * Mirrors internalapi.v1.PlanningSection; kept BFF-local to allow
 * independent evolution from the backend enum.
 *
 * @generated from enum bffuser.v1.PlanningSection
 */
export enum PlanningSection {
  /**
   * @generated from enum value: PLANNING_SECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLANNING_SECTION_SAME_DAY = 1;
   */
  SAME_DAY = 1,

  /**
   * @generated from enum value: PLANNING_SECTION_NEXT_DAY = 2;
   */
  NEXT_DAY = 2,

  /**
   * @generated from enum value: PLANNING_SECTION_DAY_AFTER_TOMORROW = 3;
   */
  DAY_AFTER_TOMORROW = 3,

  /**
   * @generated from enum value: PLANNING_SECTION_WEEKLY = 4;
   */
  WEEKLY = 4,

  /**
   * @generated from enum value: PLANNING_SECTION_MONTHLY = 5;
   */
  MONTHLY = 5,

  /**
   * @generated from enum value: PLANNING_SECTION_ANNUAL = 6;
   */
  ANNUAL = 6,
}

/**
 * Describes the enum bffuser.v1.PlanningSection.
 */
export const PlanningSectionSchema: GenEnum<PlanningSection> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_confirm_record_model, 0);

/**
 * ConfirmCategory classifies the record origin: the last-registered
 * value (最終登録値) submitted to OCCTO, or the business-confirmed
 * value (業務確定) generated when a workflow case is completed.
 * Mirrors internalapi.v1.ConfirmCategory.
 *
 * @generated from enum bffuser.v1.ConfirmCategory
 */
export enum ConfirmCategory {
  /**
   * @generated from enum value: CONFIRM_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONFIRM_CATEGORY_LAST_REGISTERED = 1;
   */
  LAST_REGISTERED = 1,

  /**
   * @generated from enum value: CONFIRM_CATEGORY_BUSINESS_CONFIRMED = 2;
   */
  BUSINESS_CONFIRMED = 2,
}

/**
 * Describes the enum bffuser.v1.ConfirmCategory.
 */
export const ConfirmCategorySchema: GenEnum<ConfirmCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_confirm_record_model, 1);

/**
 * AggregationScope classifies the demand aggregation unit:
 * full BG (BG全体), retail (小売), or demand group (需要グループ).
 * Mirrors internalapi.v1.AggregationScope.
 *
 * @generated from enum bffuser.v1.AggregationScope
 */
export enum AggregationScope {
  /**
   * @generated from enum value: AGGREGATION_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGGREGATION_SCOPE_BG_TOTAL = 1;
   */
  BG_TOTAL = 1,

  /**
   * @generated from enum value: AGGREGATION_SCOPE_RETAIL = 2;
   */
  RETAIL = 2,

  /**
   * @generated from enum value: AGGREGATION_SCOPE_DEMAND_GROUP = 3;
   */
  DEMAND_GROUP = 3,

  /**
   * @generated from enum value: AGGREGATION_SCOPE_UNATTRIBUTED = 4;
   */
  UNATTRIBUTED = 4,
}

/**
 * Describes the enum bffuser.v1.AggregationScope.
 */
export const AggregationScopeSchema: GenEnum<AggregationScope> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_confirm_record_model, 2);

/**
 * ConfirmationLeafKind is the kind of a frozen leaf of a retailer confirmed
 * by demand group: one demand group, or the retailer's residual (その他).
 *
 * @generated from enum bffuser.v1.ConfirmationLeafKind
 */
export enum ConfirmationLeafKind {
  /**
   * @generated from enum value: CONFIRMATION_LEAF_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONFIRMATION_LEAF_KIND_GROUP = 1;
   */
  GROUP = 1,

  /**
   * @generated from enum value: CONFIRMATION_LEAF_KIND_RESIDUAL = 2;
   */
  RESIDUAL = 2,
}

/**
 * Describes the enum bffuser.v1.ConfirmationLeafKind.
 */
export const ConfirmationLeafKindSchema: GenEnum<ConfirmationLeafKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_confirm_record_model, 3);

/**
 * ConfirmationDetailState tells, per koma, whether a frozen retailer's leaf
 * breakdown is known.
 *
 * @generated from enum bffuser.v1.ConfirmationDetailState
 */
export enum ConfirmationDetailState {
  /**
   * @generated from enum value: CONFIRMATION_DETAIL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * CONFIRMATION_DETAIL_STATE_KNOWN: the retailer total is the sum of its
   * leaves.
   *
   * @generated from enum value: CONFIRMATION_DETAIL_STATE_KNOWN = 1;
   */
  KNOWN = 1,

  /**
   * CONFIRMATION_DETAIL_STATE_LEGACY_UNAVAILABLE: a closed koma kept the
   * prior retailer total; the leaf breakdown is unknown.
   *
   * @generated from enum value: CONFIRMATION_DETAIL_STATE_LEGACY_UNAVAILABLE = 2;
   */
  LEGACY_UNAVAILABLE = 2,

  /**
   * CONFIRMATION_DETAIL_STATE_NOT_APPLICABLE: the retailer is confirmed
   * directly and has no leaves.
   *
   * @generated from enum value: CONFIRMATION_DETAIL_STATE_NOT_APPLICABLE = 3;
   */
  NOT_APPLICABLE = 3,
}

/**
 * Describes the enum bffuser.v1.ConfirmationDetailState.
 */
export const ConfirmationDetailStateSchema: GenEnum<ConfirmationDetailState> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_confirm_record_model, 4);

/**
 * ConfirmationSlotOrigin tells where a frozen leaf koma value came from.
 *
 * @generated from enum bffuser.v1.ConfirmationSlotOrigin
 */
export enum ConfirmationSlotOrigin {
  /**
   * @generated from enum value: CONFIRMATION_SLOT_ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * CONFIRMATION_SLOT_ORIGIN_SAVED: the saved leaf value.
   *
   * @generated from enum value: CONFIRMATION_SLOT_ORIGIN_SAVED = 1;
   */
  SAVED = 1,

  /**
   * CONFIRMATION_SLOT_ORIGIN_CLOSED_ZERO_DEFAULT: a closed koma without a
   * saved value or a prior total, resolved as 0.
   *
   * @generated from enum value: CONFIRMATION_SLOT_ORIGIN_CLOSED_ZERO_DEFAULT = 2;
   */
  CLOSED_ZERO_DEFAULT = 2,

  /**
   * CONFIRMATION_SLOT_ORIGIN_UNAVAILABLE: a closed koma whose retailer kept
   * the prior total; the leaf value is unknown.
   *
   * @generated from enum value: CONFIRMATION_SLOT_ORIGIN_UNAVAILABLE = 3;
   */
  UNAVAILABLE = 3,
}

/**
 * Describes the enum bffuser.v1.ConfirmationSlotOrigin.
 */
export const ConfirmationSlotOriginSchema: GenEnum<ConfirmationSlotOrigin> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_demand_confirm_record_model, 5);

